import React from 'react';
import {
  ListingCardContainer,
  ListingHeader,
  ListingTitle,
  ListingTitleRow,
  ListingMetaRow,
  StatusPill,
  CardCountText,
  StatRow,
  Stat,
  StatLabel,
  StatValue
} from './ListingCard.styles.js';
import PrimaryBtn from '../../../../../../components/btns/primary-btn/PrimaryBtn.js';
import { normalizeSaleStatus, isSold } from '../../../../../../utils/sales/sales.constants.js';
import { calculateNetProfit } from '../../../../../../utils/sales/salesMath.js';

export default function ListingCard({
  sale,
  onClick,
  selectable = false,
  onSelect = null
}) {
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '$0.00';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const daysListed = (timestamp) => {
    if (!timestamp) return null;
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const days = Math.floor((Date.now() - date.getTime()) / 86400000);
    return days < 0 ? 0 : days;
  };

  const status = normalizeSaleStatus(sale.status);
  const sold = isSold(sale.status);
  const netProfit = calculateNetProfit(sale);
  const title = sale.title && sale.title.trim() ? sale.title.trim() : 'Unnamed Sale';
  const cardCount = Number(sale.cardCount) || 0;
  const listedDays = sold ? null : daysListed(sale.listingDate);

  return (
    <ListingCardContainer onClick={onClick}>
      <ListingMetaRow>
        <StatusPill $sold={sold}>{status}</StatusPill>
        {cardCount > 0 && (
          <CardCountText>
            {cardCount} card{cardCount === 1 ? '' : 's'}
            {listedDays !== null && ` · ${listedDays}d`}
            {sale.ebaySku ? ` · ${sale.ebaySku}` : ''}
          </CardCountText>
        )}
      </ListingMetaRow>
      <ListingTitleRow>
        <ListingTitle>{title}</ListingTitle>
      </ListingTitleRow>
      <ListingHeader>
        <StatRow>
          <Stat>
            <StatLabel>{sold ? 'Sold' : 'Listed'}</StatLabel>
            <StatValue>{formatDate(sold ? sale.saleDate : sale.listingDate)}</StatValue>
          </Stat>
          <Stat>
            <StatLabel>Platform</StatLabel>
            <StatValue>{sale.platform ? sale.platform : 'N/A'}</StatValue>
          </Stat>
          <Stat>
            <StatLabel>{sold ? 'Profit' : 'Asking'}</StatLabel>
            <StatValue>
              {sold
                ? (netProfit ? formatCurrency(netProfit) : 'N/A')
                : formatCurrency(sale.price)}
            </StatValue>
          </Stat>
        </StatRow>
      </ListingHeader>
      {selectable && (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "8px" }}>
          <PrimaryBtn
            fullWidth={true}
            title="ADD TO SALE"
            onClick={(event) => {
              event.stopPropagation();
              onSelect?.(sale);
            }}
          />
        </div>
      )}
    </ListingCardContainer>
  );
}
